/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    ProductGalleryBaseImageContainer as SourceProductGalleryBaseImageContainer
} from 'SourceComponent/ProductGalleryBaseImage/ProductGalleryBaseImage.container';

/** @namespace Scandipwa/Component/ProductGalleryBaseImage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    cloudinaryStatus: state.ConfigReducer.isCloudinaryCDNActive
});

/** @namespace Scandipwa/Component/ProductGalleryBaseImage/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Scandipwa/Component/ProductGalleryBaseImage/Container */
export class ProductGalleryBaseImageContainer extends SourceProductGalleryBaseImageContainer {
    static propTypes = {
        ...super.propTypes,
        cloudinaryStatus: PropTypes.bool.isRequired,
        disableZoom: PropTypes.func,
        scale: PropTypes.number,
        previousScale: PropTypes.number,
        isZoomEnabled: PropTypes.bool
    };

    static defaultProps = {
        ...super.defaultProps,
        disableZoom: () => null,
        scale: 1,
        previousScale: 1,
        isZoomEnabled: true
    };

    // This is necessary to make product main image to change when user clicks on swatch colors
    shouldComponentUpdate(nextProps) {
        const { mediaData: { id, thumbnail: { url: thumbnailUrl } }, isNotZoomedIn } = this.props;
        const {
            mediaData: { id: nextId, thumbnail: { url: nextThumbnailUrl } },
            isNotZoomedIn: nextIsNotZoomedIn
        } = nextProps;

        return id !== nextId || thumbnailUrl !== nextThumbnailUrl
            || isNotZoomedIn !== nextIsNotZoomedIn;
    }

    containerProps = () => {
        const {
            cloudinaryStatus,
            onLoad,
            isZoomEnabled,
            isNotZoomedIn,
            setIsZoomedInState,
            isSliderOverlay,
            zoomIn,
            resetTransform,
            isDesktop,
            onActiveImageChange,
            index
        } = this.props;

        return ({
            alt: this._getAlt(),
            src: this._getSrc(),
            cloudinaryStatus,
            onLoad,
            isZoomEnabled,
            isNotZoomedIn,
            setIsZoomedInState,
            isSliderOverlay,
            zoomIn,
            resetTransform,
            isDesktop,
            onActiveImageChange,
            index
        });
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ProductGalleryBaseImageContainer)
);
